const backendUrl = "https://menuapi.apix.site";
// const backendUrl = "http://localhost:8080";
const baseUrl = "https://usmenus.apix.site";
const config = {
  baseUrl: baseUrl,
  apiEndpoint: backendUrl + '/api',
  authEndpoint: backendUrl + '/auth',
  backendUrl: backendUrl
  
};

export default config;
